import 'babel-polyfill'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
import App from './App.vue';
import Vuetify from 'vuetify'
import colors from 'vuetify/es5/util/colors'
import 'vuetify/dist/vuetify.min.css'
import Axios from 'axios'
import router from './router'
import 'material-design-icons-iconfont'
import store from './store'
import DateFilter from './filters/date'
import VueScrollTo from 'vue-scrollto'
import * as CONFIG from './config'

Vue.use(Vuetify, {
    theme: {
        primary: colors.purple.darken4, // #E53935
        secondary: colors.grey.darken3, // #FFCDD2
        accent: colors.grey.base // #3F51B5
    }
})
Vue.use(VueScrollTo);
Vue.config.productionTip = false;
Vue.filter('date', DateFilter);
Axios.defaults.baseURL = CONFIG.BETAPI;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
